import { capitalize } from "./strings";

export type TrainingStep =
  | "uploadSelfie"
  | "name"
  | "gender"
  | "age"
  | "hairStyle"
  | "hairColor"
  | "skinTone"
  | "eyeColor"
  | "glasses"
  | "facialHairStyle"
  | "facialHairColor"
  | "selectPhotoPack"
  | "uploadTrainingPhotos"
  | "review";

const stepNameMap: Record<TrainingStep, string> = {
  uploadSelfie: "Upload Selfie",
  name: "Your Name",
  gender: "Gender",
  age: "Age",
  hairStyle: "Hair Style",
  hairColor: "Hair Color",
  skinTone: "Skin Tone",
  eyeColor: "Eye Color",
  glasses: "Glasses",
  facialHairStyle: "Facial Hair Style",
  facialHairColor: "Facial Hair Color",
  selectPhotoPack: "Select Photo Pack",
  uploadTrainingPhotos: "Upload Training Photos",
  review: "Review & Submit",
};

/**
 * Converts a step ID into a user-friendly display name
 */
export function getStepDisplayName(step: TrainingStep): string {
  if (step in stepNameMap) {
    return stepNameMap[step];
  }

  // Fallback: convert camelCase to words and capitalize first letter
  const words = step.replace(/([A-Z])/g, " $1").trim();
  return capitalize(words);
}
